import React, {Component, Fragment} from 'react';
import FullProfileModalBase from "./FullProfileModalBase";
import GoalsMap from "../../../../ui/canvases/GoalMap";
import {Image} from "react-bootstrap";
import Tools from "../../../../../Tools";
import '../../../../../assets/sass/pages/full-profile/tabs/modals/assists-by-player-modal.scss';
import dustinWilliamsonAvatar from "../../../../../assets/img/demo/dustin-williamson-avatar.png";
import brandonPenaAvatar from "../../../../../assets/img/demo/brandon-pena-avatar.png";
import eduardoMilesAvatar from "../../../../../assets/img/demo/eduardo-miles-avatar.png";
import GoalScoreArea from "../../../../ui/canvases/GoalScoreArea";

// TODO: Fetch goals from API.
// Goal area [ x: [-160, 160] y:[], z:[0, 150]

const goal1 = {
    steps: [
        {x: 225, y: 100, name: "Dustin Williamson", avatar: dustinWilliamsonAvatar},
        {x: 370, y: 250, name: "Brandon Pena", avatar: brandonPenaAvatar},
        {x: 225, y: 440, name: "Eduardo Miles", avatar: eduardoMilesAvatar},
        {x: 110, y: 600, z: 120, isGoal: true},
    ],
    order: 1,
    minuets: 62,
};
const goal2 = {
    steps: [
        {x: 0, y: 300, name: "Dustin Williamson", avatar: dustinWilliamsonAvatar},
        {x: -240, y: 480, name: "Brandon Pena", avatar: brandonPenaAvatar},
        {x: -50, y: 600, z: 40, isGoal: true},
    ],
    order: 2,
    minuets: 69,
};
const goals = [goal1, goal2];

class AssistsByPlayerModal extends FullProfileModalBase {

    constructor(props) {
        super(props);

        this.state = {
            goals: goals,
            dx: 1,
            dy: 1,
            dz: 1.
        };
    }

    /**
     * Render the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderGoalMap()}
                {this.renderGoals()}
            </Fragment>
        );
    };

    // componentDidMount() {
    //     const tx = 450;
    //     const ty = 320;
    //     const tz = 500;
    //     const fact = 5;
    //
    //     setInterval(() => {
    //         const {dx, dy, dz} = this.state;
    //
    //         console.log(
    //             dx,
    //             dy,
    //             dx,
    //             this.state.goals[0].steps[3].x,
    //             this.state.goals[0].steps[3].y,
    //             this.state.goals[0].steps[3].z,
    //         );
    //
    //         const newState = this.state;
    //         newState.goals[0].steps[3].x += fact * dx;
    //
    //         if (newState.goals[0].steps[3].x > 150)
    //             this.setState({...this.state, dx: -1});
    //         else if (newState.goals[0].steps[3].x < -150)
    //             this.setState({...this.state, dx: 1});
    //
    //         else this.setState(newState);
    //
    //         this.forceUpdate();
    //     }, tx);
    //
    //     setInterval(() => {
    //         const {dx, dy, dz} = this.state;
    //
    //         const newState = this.state;
    //         newState.goals[0].steps[3].y += fact * dy;
    //
    //         if (newState.goals[0].steps[3].y > 600)
    //             this.setState({...this.state, dy: -1});
    //         else if (newState.goals[0].steps[3].y < 50)
    //             this.setState({...this.state, dy: 1});
    //
    //         else this.setState(newState);
    //         this.forceUpdate();
    //
    //     }, ty);
    //
    //
    //     setInterval(() => {
    //         const {dx, dy, dz} = this.state;
    //
    //         const newState = this.state;
    //         newState.goals[0].steps[3].z += fact * dz;
    //
    //         if (newState.goals[0].steps[3].z > 60)
    //             this.setState({...this.state, dz: -1});
    //         else if (newState.goals[0].steps[3].z < 10)
    //             this.setState({...this.state, dz: 1});
    //
    //         else this.setState(newState);
    //         this.forceUpdate();
    //
    //     }, tz);
    // }

    renderGoals = () => {
        const {goals} = this.state;

        return (
            <div className="goals"> {goals.map((goal) => this.renderGoal(goal))} </div>
        );
    };

    renderGoal = (goal, index) => {
        const {steps, order, minuets} = goal;
        return (
            <div className="goal" key={index}>
                <div className="header"> {this.formatGoalHeader(order, minuets)} </div>
                {this.renderGoalSteps(steps)}
            </div>
        );
    };

    renderGoalSteps = (steps) => {
        return (
            <div className="steps-container">
                <div className="steps-player"> {steps.filter(step => !step.isGoal).map((step, index) => this.renderGoalStep(step, index))} </div>
                <div className="steps-goal"> {steps.filter(step => step.isGoal).map((step, index) => this.renderGoalStep(step, index))} </div>
            </div>
        );
    };

    renderGoalStep = (step, index) => {
        const {isGoal} = step;
        if (isGoal) {
            return this.renderScoreGoal(step);
        } else {
            return this.renderPlayerStep(step, index);
        }
    };

    renderScoreGoal = (goalStep) => {
        const {x, z} = goalStep;
        // x: [-160 -> 160]
        // z: [0 -> 150]

        const goalScoreAreaText = this.goalScoreAreaText();
        return (
            <Fragment>
                {this.renderArrow()}
                <div className="goal-step">
                    <GoalScoreArea ball={{x: x, z: z}}/>
                    <div className="text"> {goalScoreAreaText} </div>
                </div>
            </Fragment>
        );
    };

    renderPlayerStep = (playerStep, index) => {
        const {name, avatar} = playerStep;
        return (
            <Fragment>
                {index !== 0 && this.renderArrow()}
                <div className="player-step">
                    <Image roundedCircle src={avatar}/>
                    <div className="name"> {name} </div>
                </div>
            </Fragment>
        )
    };

    renderArrow = () => {
        return (
            <div className="arrow">
                <div className="line"/>
                <span className="right-vertex"/>
            </div>
        );
    };


    formatGoalHeader = (order, minuets) => `${Tools.numberingSuffix(order)} Goal | ${minuets}’`;

    /**
     * Renders the goal path of goals.
     * @returns {React.ReactNode} The goal map.
     */
    renderGoalMap = () => {
        const {goals} = this.state;

        return (
            <GoalsMap goals={goals}/>
        );
    };


    goalScoreAreaText = () => "Goal Score Area";

    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "lg";

    /**
     * Returns classname of modal.
     * @returns {string} The classname modal.
     */
    modalClassname = () => "assists-by-player-modal";

    static defaultProps = {
        headerTitle: "Assists by Player",
        headerSubtitle: "2 of 2 | 100% Accuracy",
    };
}

export default AssistsByPlayerModal;
